// Builds a skills × (roles + projects) grid from the site's own content, using
// the same matching as the "where I've used it" panel, so the two always agree.
import { findSkillEvidence } from './skillEvidence';

export function buildSkillMap(skillGroups, experience, projects, aliases) {
    const columns = [
        ...experience.map((job) => ({
            key: `role-${job.id}`,
            kind: 'Role',
            label: job.company,
            detail: job.jobtitle,
        })),
        ...projects.map((project) => ({
            key: `project-${project.id}`,
            kind: 'Project',
            label: project.projectName,
            detail: 'Project',
        })),
    ];

    const rows = skillGroups.flatMap((group) =>
        group.items.map((skill) => {
            const evidence = findSkillEvidence(skill, experience, projects, aliases);
            const hits = new Set([
                ...evidence.roles.map((role) => `role-${role.id}`),
                ...evidence.projects.map((project) => `project-${project.id}`),
            ]);
            return { skill, category: group.category, hits, count: hits.size };
        })
    );

    // Most-evidenced first; ties keep the order they have on the site.
    const sorted = rows
        .map((row, index) => ({ row, index }))
        .sort((a, b) => b.row.count - a.row.count || a.index - b.index)
        .map(({ row }) => row);

    return { columns, rows: sorted };
}
